import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { GroupOrderBagButton } from '../GroupOrderBagButton/GroupOrderBagButton';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagConvertButton = (props: Props) => {
  const { isDisabled, onPress } = props;

  const { formatMessage } = useIntl();

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <GroupOrderBagButton
      icon="IconAccountPlus"
      iconSize={24}
      accessibilityLabel={formatMessage(messages.label)}
      isDisabled={isDisabled}
      onPress={onPress}
    >
      <FormattedMessage {...messages.label} />
    </GroupOrderBagButton>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  label: {
    defaultMessage: 'Make this a group order',
    description: 'Bag | Group order | Convert to group order CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isDisabled: boolean;
  onPress: () => void;
};
